import actionTypes from '../constants/action-types';

const setIntegrations = (integrations) => ({
  type: actionTypes.SET_INTEGRATIONS,
  payload: {
    integrations,
  },
});

export default setIntegrations;
